module.exports = __webpack_public_path__ + "img/cover5.6e840706.png";